// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ii_c","col":"styles_col__1jO19","actions":"styles_actions__11KQA","conflict":"styles_conflict__2Sd9k"};